import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useViewEntityDialogStyles = makeStyles({
  dialogSurface: {
    maxWidth: "650px",
    maxHeight: "80vh",
  },
  dialogSurfaceCompact: {
    maxWidth: "650px",
    maxHeight: "65vh",
  },
  dialogContent: {
    height: "calc(80vh - 120px)",
    paddingBottom: designTokens.spacing[4],
    display: "flex",
    flexDirection: "column",
  },
  dialogContentCompact: {
    height: "calc(60vh - 120px)",
    paddingBottom: designTokens.spacing[4],
    display: "flex",
    flexDirection: "column",
  },
  fieldContainer: {
    marginBottom: designTokens.spacing[3],
  },
  fieldLabel: {
    fontWeight: designTokens.fontWeight.semibold,
    marginBottom: designTokens.spacing[1],
    fontSize: designTokens.fontSize.sm,
  },
  fieldValue: {
    color: designTokens.neutral[900],
    fontSize: designTokens.fontSize.sm,
  },
  dialogActions: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: designTokens.spacing[4],
  },
  actionButtons: {
    display: "flex",
    justifyContent: "flex-end",
    gap: designTokens.spacing[2],
    width: "100%",
  },
  tabContent: {
    flex: 1,
    overflowY: "auto" as const,
  },
  hidden: {
    visibility: "hidden",
  },
});
